import "./App.css";
import Navigation from "./Components/Navigation";
import "@fontsource/roboto/400.css";
import ContactUs from "./Components/ContactUs";
import AboutUs from "./Components/AboutUs";
import FooterNew from "./Components/FooterNew";
import Portfolio from "./Components/Portfolio";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Components/HomePage";
import Services from "./Components/Services";
import AdminLogin from "./Components/Admin/AdminLogin";
import Amplify from "@aws-amplify/core";
import config from "../src/aws-exports";
import { createStandaloneToast } from "@chakra-ui/toast";
Amplify.configure(config);

const { ToastContainer } = createStandaloneToast();

function App() {
  useEffect(() => {
    window.gtag("config", "AW-696694130");
  }, []);
  return (
    <div>
      <ToastContainer />
      <Router>
        <Routes>
          {/* Admin route — no nav/footer */}
          <Route path="/admin/*" element={<AdminLogin />} />

          {/* Public routes — with nav + footer */}
          <Route path="*" element={<PublicLayout />} />
        </Routes>
      </Router>
    </div>
  );
}

function PublicLayout() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Navigation />
      <main style={{ flexGrow: 1 }}>
        <AppRoutes />
      </main>
      <FooterNew />
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/estimate" element={<ContactUs />}></Route>
      <Route path="/estimate/" element={<ContactUs />}></Route>
      <Route path="/about" element={<AboutUs />}></Route>
      <Route path="/about/" element={<AboutUs />}></Route>
      <Route path="/portfolio" element={<Portfolio />}></Route>
      <Route path="/portfolio/" element={<Portfolio />}></Route>
      <Route path="/services" element={<Services />}></Route>
      <Route path="/services/" element={<Services />}></Route>
      <Route path="*" element={<HomePage />}></Route>
    </Routes>
  );
}
export default App;
